import { allowedRoles } from "roles_management/rolesList";
import { generateSpecificModuleRoutes, isFrontendLayout } from "./RouteHandler";
import {
    DistrictForm,
    LabsView,
    LandingPage,
    ListForm,
    MetaDataManagement,
    ProvinceForm,
    TehsilForm,
    UCForm,
    AcfActivities,
    RegisteredParticipants,
    ParticipantDetailPage,
    UsersList,
    UserForm,
    RolesList,
    RolesForm,
    PermissionsView,
    PermissionAssignment,
    AccountDeletionRequestForm,
    AcfActivityForm,
    StatisticsDashboard,
    AcfActivitiesListing,
    ParticipantsListing,
    PrivacyPolicy
} from "routes_management";
import PermissionForm from "pages/frontend/role-management/PermissionsForm";

/**
 * This function is responsible for generating routes of the system.
 * @param {object|null} user 
 * @returns 
 */
export const generateRoutes = (user = null) => {
    return [
        ...generateSpecificModuleRoutes({
            hasWrapper: false,
            moduleAllowedRoles: { ...allowedRoles, 'M&E_MANAGER': true, TEMP_LIMITED_ROLE: true },
            moduleLayout: isFrontendLayout('FrontendLayout'),
            isSecureModule: true,
            userRole: user ? user.role_id : null
        }, [
            {
                path: "/",
                element: <LandingPage />,
            },
            {
                path: "/privacy-policy",
                element: <PrivacyPolicy />,
            },
            {
                path: "/acf-activities",
                element: <AcfActivities />,
            },
            {
                path: "/acf-activities/create",
                element: <AcfActivityForm />,
            },
            {
                path: "/acf-activities/:id/edit",
                element: <AcfActivityForm />,
            },
            {
                path: "/participants/:id",
                element: <RegisteredParticipants />,
            },
            {
                path: "/participant/:id/detail",
                element: <ParticipantDetailPage />,
            },
            {
                path: "/delete-account",
                element: <AccountDeletionRequestForm />
            }
        ]),

        // UserManagement routes
        ...generateSpecificModuleRoutes({
            hasWrapper: false,
            modulePrefix: "/portal/user-management",
            moduleAllowedRoles: allowedRoles,
            moduleLayout: isFrontendLayout('FrontendLayout'),
            isSecureModule: true,
            userRole: user ? user.role_id : null
        }, [
            {
                path: "/",
                element: <UsersList />,
            },
            {
                path: "/create",
                element: <UserForm />,
            },
            {
                path: "/:id/edit",
                element: <UserForm />,
            },
        ]),


        // RolesManagement routes
        ...generateSpecificModuleRoutes({
            hasWrapper: false,
            modulePrefix: "/portal/role-management",
            moduleAllowedRoles: allowedRoles,
            moduleLayout: isFrontendLayout('FrontendLayout'),
            isSecureModule: true,
            userRole: user ? user.role_id : null
        }, [
            {
                path: "/",
                element: <RolesList />,
            },
            {
                path: "/create",
                element: <RolesForm />,
            },
            {
                path: "/:id/edit",
                element: <RolesForm />,
            },
        ]),

        // PermissionsManagement routes
        ...generateSpecificModuleRoutes({
            hasWrapper: false,
            modulePrefix: "/portal/permissions",
            moduleAllowedRoles: allowedRoles,
            moduleLayout: isFrontendLayout('FrontendLayout'),
            isSecureModule: true,
            userRole: user ? user.role_id : null
        }, [
            {
                path: "/",
                element: <PermissionsView />,
            },
            {
                path: "/create",
                element: <PermissionForm />,
            },
            {
                path: "/:id/edit",
                element: <PermissionForm />,
            },
            {
                path: "/assign-permissions",
                element: <PermissionAssignment />,
            },
        ]),

        // MetaDataManagement routes
        ...generateSpecificModuleRoutes({
            hasWrapper: false,
            modulePrefix: "/portal/meta-data",
            moduleAllowedRoles: allowedRoles,
            moduleLayout: isFrontendLayout('FrontendLayout'),
            isSecureModule: true,
            userRole: user ? user.role_id : null
        }, [
            {
                path: "/",
                element: <MetaDataManagement />,
            },
            {
                path: `/list-elements/:key`,
                element: <ListForm />,
            },
            {
                path: "/labs",
                element: <LabsView />,
            },
            {
                path: "/provinces",
                element: <ProvinceForm />,
            },
            {
                path: "/districts",
                element: <DistrictForm />,
            },
            {
                path: "/tehsils",
                element: <TehsilForm />,
            },
            {
                path: "/ucs",
                element: <UCForm />,
            },
        ]),

        // Qualitative routes
        ...generateSpecificModuleRoutes({
            hasWrapper: false,
            modulePrefix: "/portal/qualitative",
            moduleAllowedRoles: { ...allowedRoles, 'M&E_MANAGER': true, },
            moduleLayout: isFrontendLayout('FrontendLayout'),
            isSecureModule: true,
            userRole: user ? user.role_id : null
        }, [
            {
                path: "/",
                element: <StatisticsDashboard />,
            },
            {
                path: "/line-listing-acf-activities",
                element: <AcfActivitiesListing />,
            },
            {
                path: "/line-listing-participants",
                element: <ParticipantsListing />,
            }
        ]),
    ];
}
